import { Editor } from '@tiptap/core';

export const getImmediateBlockParentForPosition = (
  editor: Editor,
  position: number,
) => {
  const $pos = editor.state.doc.resolve(position);

  for (let depth = $pos.depth; depth > 0; depth--) {
    const node = $pos.node(depth);

    if (node.isBlock) {
      return {
        node,
        start: $pos.start(depth),
        end: $pos.end(depth),
        contentStart: $pos.start(depth) + 1,
        contentEnd: $pos.start(depth) + node.content.size,
      };
    }
  }

  return null;
};
export const getEntireNodePositionFromPosition = (
  editor: Editor,
  position: number,
) => {
  const $pos = editor.state.doc.resolve(position);

  return {
    start: $pos.start(),
    end: $pos.end(),
    contentStart: $pos.start() + 1,
    contentEnd: $pos.end(),
  };
};

export const getBlockNodeFromPosition = (editor: Editor, position: number) => {
  const node = editor.state.doc.nodeAt(position);

  if (node == null) {
    return null;
  }

  if (node?.isBlock) {
    return {
      node,
      ...getEntireNodePositionFromPosition(editor, position),
    };
  }
  const parentNodeInfo = getImmediateBlockParentForPosition(editor, position);

  if (parentNodeInfo == null) {
    return null;
  }

  return parentNodeInfo;
};
